import React from 'react'
import IconTypeEnum from '../../models/icon-type-enum'
import IconColorEnum from '../../models/icon-color-enum'

interface Props {
    icon: IconTypeEnum
    color?: IconColorEnum
}

export default function Icons({
    icon,
    color = IconColorEnum.GrayColor,
}: Props): JSX.Element {
    switch (icon) {
        case IconTypeEnum.HomeIcon:
            return (
                <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M23.3553 10.4399L23.3537 10.4383L13.5626 0.647527C13.1452 0.230004 12.5904 0 12.0001 0C11.4099 0 10.8551 0.229821 10.4376 0.647344L0.65158 10.4331C0.648284 10.4364 0.644988 10.4399 0.641692 10.4432C-0.215329 11.3052 -0.213864 12.7037 0.645903 13.5635C1.0387 13.9564 1.5575 14.1841 2.11218 14.2079C2.1347 14.2101 2.15741 14.2112 2.1803 14.2112H2.57054V21.4166C2.57054 22.8424 3.73063 24.0025 5.1568 24.0025H8.98739C9.37561 24.0025 9.69059 23.6877 9.69059 23.2993V17.6502C9.69059 16.9996 10.2198 16.4704 10.8705 16.4704H13.1298C13.7805 16.4704 14.3097 16.9996 14.3097 17.6502V23.2993C14.3097 23.6877 14.6245 24.0025 15.0129 24.0025H18.8435C20.2697 24.0025 21.4298 22.8424 21.4298 21.4166V14.2112H21.7916C22.3816 14.2112 22.9365 13.9814 23.3542 13.5638C24.2149 12.7026 24.2153 11.3017 23.3553 10.4399Z"
                        fill="#C0C0C0"
                    />
                </svg>
            )
        case IconTypeEnum.CareersEnforcerIcon:
            return (
                <svg
                    width="26"
                    height="32"
                    viewBox="0 0 26 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M13 0L0 2.25143V7.41143V21.1771L13 32L26 21.1771V7.41143V2.25143L13 0Z"
                        fill={color}
                    />
                </svg>
            )

        case IconTypeEnum.CareersExplorerIcon:
            return (
                <svg
                    width="32"
                    height="28"
                    viewBox="0 0 32 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M23.8366 13.8746C23.8359 12.8001 24.2612 11.7671 25.023 10.9934C25.7848 10.2196 26.8235 9.76546 27.9205 9.72651C26.8761 6.53688 24.698 3.81953 21.7817 2.06765C18.8654 0.315757 15.4041 -0.354557 12.0261 0.178376C8.648 0.711309 5.57707 2.41216 3.37065 4.97223C1.16422 7.5323 -0.0314475 10.7819 0.000629016 14.1312C0.0327055 17.4806 1.2904 20.7077 3.54547 23.2268C5.80053 25.7459 8.90349 27.3901 12.2912 27.861C15.6788 28.3318 19.1267 27.5981 22.0089 25.793C24.8912 23.9879 27.0168 21.231 28 18.0228C26.889 18.0037 25.8302 17.5583 25.0514 16.7825C24.2727 16.0066 23.8365 14.9623 23.8366 13.8746Z"
                        fill={color}
                    />
                    <path
                        d="M27.1749 10H27C28.0094 12.5972 28.041 15.3876 27.0905 18H27.1749C28.4546 18 29.6819 17.5786 30.5868 16.8284C31.4916 16.0783 32 15.0609 32 14C32 12.9391 31.4916 11.9217 30.5868 11.1716C29.6819 10.4214 28.4546 10 27.1749 10Z"
                        fill={color}
                    />
                </svg>
            )

        case IconTypeEnum.CareersIndustrialistIcon:
            return (
                <svg
                    width="32"
                    height="29"
                    viewBox="0 0 32 29"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M23.9958 0.793457H8.00422L0 14.6566L8.00422 28.5029H23.9958L32 14.6398L23.9958 0.793457ZM15.9916 20.2914C14.8772 20.2914 13.7877 19.961 12.8611 19.3418C11.9344 18.7226 11.2122 17.8426 10.7857 16.8129C10.3592 15.7833 10.2476 14.6503 10.465 13.5573C10.6825 12.4642 11.2191 11.4602 12.0072 10.6721C12.7952 9.88407 13.7992 9.3474 14.8923 9.12998C15.9854 8.91256 17.1184 9.02415 18.148 9.45064C19.1776 9.87713 20.0577 10.5994 20.6768 11.526C21.296 12.4527 21.6265 13.5421 21.6265 14.6566C21.628 16.1486 21.0371 17.5801 19.9837 18.6367C18.9302 19.6933 17.5004 20.2885 16.0084 20.2914H15.9916Z"
                        fill={color}
                    />
                </svg>
            )

        case IconTypeEnum.CareersSoldierOfFortuneIcon:
            return (
                <svg
                    width="28"
                    height="33"
                    viewBox="0 0 28 33"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M28 14.1397C27.9992 12.0142 27.5242 9.91609 26.6105 8.00148C25.6968 6.08687 24.3678 4.40493 22.7222 3.08067C21.0766 1.75641 19.1568 0.82388 17.1055 0.352386C15.0542 -0.119107 12.924 -0.117433 10.8734 0.35727C8.8228 0.831972 6.90444 1.7675 5.2609 3.09433C3.61736 4.42116 2.29088 6.10518 1.38008 8.02122C0.469294 9.93726 -0.00243202 12.0361 9.42873e-06 14.1616C0.00245088 16.2872 0.478994 18.3849 1.39418 20.2988L0.583342 24.1592C2.90399 24.1592 5.12956 25.0907 6.7705 26.7486C8.41144 28.4066 9.33334 30.6553 9.33334 33H18.6667C18.6667 30.6553 19.5886 28.4066 21.2295 26.7486C22.8704 25.0907 25.096 24.1592 27.4167 24.1592L26.6058 20.2988C27.5261 18.3789 28.0028 16.2729 28 14.1397ZM7.58334 23.5699C6.66036 23.5699 5.7581 23.2933 4.99067 22.7752C4.22324 22.2571 3.62514 21.5207 3.27193 20.6592C2.91872 19.7976 2.82626 18.8496 3.00632 17.9349C3.18639 17.0203 3.63086 16.1801 4.2835 15.5207C4.93615 14.8613 5.7677 14.4123 6.67295 14.2303C7.57819 14.0484 8.5165 14.1418 9.36922 14.4986C10.2219 14.8555 10.9507 15.4598 11.4635 16.2352C11.9763 17.0106 12.25 17.9222 12.25 18.8548C12.25 20.1053 11.7583 21.3046 10.8832 22.1889C10.008 23.0731 8.82101 23.5699 7.58334 23.5699ZM12.25 25.45L13.4167 22.5031H14.5833L15.75 25.45H12.25ZM20.4167 23.5699C19.4937 23.5699 18.5914 23.2933 17.824 22.7752C17.0566 22.2571 16.4585 21.5207 16.1053 20.6592C15.752 19.7976 15.6596 18.8496 15.8396 17.9349C16.0197 17.0203 16.4642 16.1801 17.1168 15.5207C17.7695 14.8613 18.601 14.4123 19.5063 14.2303C20.4115 14.0484 21.3498 14.1418 22.2025 14.4986C23.0553 14.8555 23.7841 15.4598 24.2968 16.2352C24.8096 17.0106 25.0833 17.9222 25.0833 18.8548C25.0833 20.1053 24.5917 21.3046 23.7165 22.1889C22.8413 23.0731 21.6543 23.5699 20.4167 23.5699Z"
                        fill={color}
                    />
                </svg>
            )

        case IconTypeEnum.ShipsDestroyersIcon:
            return (
                <svg
                    width="32"
                    height="26"
                    viewBox="0 0 32 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M31.9991 13.0769L16.0191 0L0.0390625 13.0769V18.9872H31.9991V13.0769ZM26.4993 14.4872H5.49889L15.9924 5.91024L26.4993 14.4872Z"
                        fill={color}
                    />
                    <path
                        d="M5.72205e-06 26L32 26V21.5L5.72205e-06 21.5V26Z"
                        fill={color}
                    />
                </svg>
            )

        case IconTypeEnum.ShipsFrigatesIcon:
            return (
                <svg
                    width="32"
                    height="20"
                    viewBox="0 0 32 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M32.0001 13.788L16.0201 0.0135498L0.0400391 13.788V20.0001H32.0001V13.788ZM26.5003 15.2735H5.49987L15.9934 6.22558L26.5003 15.2735Z"
                        fill={color}
                    />
                </svg>
            )

        case IconTypeEnum.ShipsMiningShipsIcon:
            return (
                <svg
                    width="32"
                    height="23"
                    viewBox="0 0 32 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M24.5354 0H7.49521L0 6.91825V22.9501H32V6.88501L24.5354 0ZM26.6616 17.1626H5.39962V9.64568L9.51434 5.83728H22.5469L26.6616 9.64568V17.1626Z"
                        fill={color}
                    />
                </svg>
            )

        case IconTypeEnum.World:
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="31"
                    fill="none"
                    viewBox="0 0 40 31"
                >
                    <path
                        fill={color}
                        d="m11.716 18.28-.544-2.453 3.583-9.839c.375.24.807.402 1.27.463L11.717 18.28Zm10.816-3.264a2.28 2.28 0 0 1 1.163-.687L18.54 5.633a3.037 3.037 0 0 1-1.163.691l5.155 8.692Zm-.606 1.533-9.02 2.626 2.737.61 6.658-1.938c-.24-.367-.379-.8-.379-1.27.004-.008.004-.02.004-.028Zm2.595-2.27c.471.058.896.255 1.236.548l2.17-4.912a2.658 2.658 0 0 1-1.236-.544l-2.17 4.908Zm5.545-4.928a2.688 2.688 0 0 1-1.232.56l6.557 14.361c.336-.297.76-.498 1.228-.56l-6.553-14.36Z"
                        opacity=".75"
                    />
                    <path
                        fill={color}
                        d="M16.025 6.451a3.084 3.084 0 0 1-2.691-3.062 3.088 3.088 0 1 1 6.178 0c0 .884-.374 1.68-.973 2.244a3.038 3.038 0 0 1-1.162.69 3.01 3.01 0 0 1-1.352.128Zm15.045.8a2.704 2.704 0 1 0-4.38 2.12c.352.277.777.47 1.236.544.143.023.29.039.44.039.163 0 .317-.016.472-.047A2.694 2.694 0 0 0 31.07 7.25Zm-6.828 7.008c-.189 0-.37.027-.548.07a2.306 2.306 0 0 0-1.162.687 2.3 2.3 0 0 0-.606 1.533v.027a2.317 2.317 0 1 0 2.595-2.301c-.093-.008-.186-.016-.279-.016Zm12.686 9.426c-.105 0-.205.008-.305.023a2.312 2.312 0 0 0-2.012 2.294 2.316 2.316 0 1 0 2.316-2.317Zm-25.065-4.742-.147-.664-.545-2.452-1.054-4.746-1.75 7.862-7.861 1.75 7.858 1.745 1.75 7.862 1.745-7.858 7.862-1.75-4.082-.907-2.738-.61-1.038-.232Z"
                    />
                </svg>
            )

        case IconTypeEnum.AuraIcon:
            return (
                <svg
                    width="44"
                    height="46"
                    viewBox="0 0 44 46"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M33.586 21.19c-.82 1.775-1.43 2.5-2.09 2.65-.57 1.705-1.095 4.26-2.74 6.68L24.4 34.885h-4.71l-4.025-4.035c0-.02-.005-.045-.005-.065-1.795-2.495-2.325-5.18-2.915-6.945-.665-.15-1.275-.88-2.09-2.65-.935-2.02-1.79-4.08-.74-5.055.735-.68 1.395-.14 1.72.245-.01-1.445-.01-3.275-.01-5.65 0-2.235.53-3.975 1.345-5.335-.115 3.235 1.445 4.665 1.445 4.665h2.405l2.795 1.805V10.45L16.49 8.13s-2.08-2.765.65-6.345C19.676.62 22.126.58 22.126.58s2.325.035 4.785 1.11c2.84 3.625.725 6.435.725 6.435L24.5 10.45v1.415l2.795-1.805H29.7s1.63-1.49 1.435-4.875c.89 1.39 1.48 3.19 1.48 5.55 0 2.375 0 4.205-.01 5.65.33-.385.985-.925 1.72-.245 1.05.97.195 3.03-.74 5.05Zm.905 21.115-1.345-1.345v-1.6l3.665 2.535 1.38 1.38h5.175c-2.22-3.035-5.66-4.47-8.56-5.015-2.9-.545-5.42-2.645-6.045-3.965-.165-.345-.235-.85-.265-1.405l-3.8 3.805h-5.32l-3.66-3.66c-.03.495-.11.945-.255 1.26-.62 1.32-3.14 3.42-6.04 3.965-2.9.545-6.34 1.985-8.71 5.015h5.18l1.38-1.38 3.665-2.535v1.6L9.59 42.305v1.93l3.04 1.275h18.82l3.04-1.275v-1.93Z"
                        fill="#c0c0c0"
                    />
                </svg>
            )

        case IconTypeEnum.ArrowRight:
            return (
                <svg
                    width="20"
                    height="14"
                    viewBox="0 0 20 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    data-name="arrow-right"
                >
                    <path
                        d="M19.7276 6.22402L13.776 0.272345C13.4128 -0.0907816 12.8239 -0.0907816 12.4608 0.272345C12.0976 0.635546 12.0976 1.22431 12.4608 1.58752L16.8249 5.95165H0.929949C0.416394 5.95165 0 6.36805 0 6.8816C0 7.39508 0.416394 7.81155 0.929949 7.81155H16.8249L12.4609 12.1757C12.0977 12.5389 12.0977 13.1277 12.4609 13.4909C12.6425 13.6723 12.8805 13.7632 13.1185 13.7632C13.3565 13.7632 13.5945 13.6723 13.7761 13.4909L19.7276 7.53919C20.0908 7.17599 20.0908 6.58722 19.7276 6.22402Z"
                        fill={color}
                    />
                </svg>
            )
        case IconTypeEnum.ArrowDown:
            return (
                <svg
                    width="14"
                    height="21"
                    viewBox="0 0 14 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M7.65782 20.6092L13.6095 14.6576C13.9726 14.2944 13.9726 13.7055 13.6095 13.3424C13.2463 12.9792 12.6575 12.9792 12.2943 13.3424L7.93018 17.7065L7.93018 1.81154C7.93018 1.29799 7.51379 0.881592 7.00023 0.881591C6.48675 0.881591 6.07028 1.29799 6.07028 1.81154L6.07028 17.7065L1.70615 13.3425C1.34295 12.9793 0.754176 12.9793 0.390974 13.3425C0.209523 13.5241 0.118612 13.7621 0.118612 14.0001C0.118612 14.2381 0.209523 14.4761 0.390974 14.6577L6.34265 20.6092C6.70585 20.9724 7.29462 20.9724 7.65782 20.6092Z"
                        fill={color}
                    />
                </svg>
            )

        case IconTypeEnum.TextIcon:
            return (
                <svg
                    width="32"
                    height="38"
                    viewBox="0 0 32 38"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M26.823 0H5.177C2.321 0 0 2.343 0 5.225v27.55C0 35.657 2.32 38 5.176 38h21.648C29.679 38 32 35.657 32 32.775V5.225C32 2.343 29.68 0 26.823 0ZM23.06 32.3H8.94c-.78 0-1.412-.638-1.412-1.425s.633-1.425 1.412-1.425H23.06c.78 0 1.412.638 1.412 1.425s-.633 1.425-1.412 1.425Zm0-7.6H8.94c-.78 0-1.412-.638-1.412-1.425s.633-1.425 1.412-1.425H23.06c.78 0 1.412.638 1.412 1.425s-.633 1.425-1.412 1.425Zm0-6.65H8.94c-.78 0-1.412-.638-1.412-1.425S8.162 15.2 8.941 15.2H23.06c.78 0 1.412.638 1.412 1.425s-.633 1.425-1.412 1.425Zm0-7.6H8.94c-.78 0-1.412-.638-1.412-1.425S8.162 7.6 8.941 7.6H23.06c.78 0 1.412.638 1.412 1.425s-.633 1.425-1.412 1.425Z"
                        fill="silver"
                    />
                </svg>
            )
        case IconTypeEnum.EasyIcon:
            return (
                <svg
                    width="32"
                    height="28"
                    viewBox="0 0 32 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M15.0624 5.917V0c-3.6138.2074-7.0028 1.6118-9.708 4.0226L9.538 8.206c1.5744-1.3107 3.4861-2.1028 5.5244-2.289ZM8.2121 9.532 4.0287 5.3487C1.6157 8.053.2097 11.4422.001 15.057h5.9173c.1875-2.0388.9812-3.9506 2.2938-5.5248Zm17.8698 5.5249h5.9173c-.2087-3.6147-1.6147-7.004-4.0277-9.7083l-4.1834 4.1835c1.3125 1.5742 2.1063 3.486 2.2938 5.5248Zm-.0013 1.8747c-.3101 3.4061-2.1799 5.4844-2.9222 6.2266-.3668.3668-.3668.9614 0 1.3281l2.8445 2.8447a.936.936 0 0 0 .664.2751.9358.9358 0 0 0 .664-.2751c2.8078-2.8074 4.445-6.4709 4.669-10.3994h-5.9193ZM5.8167 22.3108a247.95 247.95 0 0 1 1.1337-1.7644c-.4874-.9661-.8996-2.1706-1.031-3.6148H0c.224 3.9285 1.8613 7.592 4.669 10.3995a.936.936 0 0 0 .664.275.9365.9365 0 0 0 .664-.275l.974-.9741a2.8159 2.8159 0 0 1-.7704-.5473c-.9392-.9394-1.0972-2.3781-.384-3.4989ZM16.9375 0v5.917c2.0384.1863 3.9501.9784 5.5244 2.289l4.1835-4.1834C23.9404 1.6116 20.5514.2074 16.9375 0Zm-3.0204 13.9268c-1.451 1.451-6.0042 8.582-6.5185 9.3903a.9376.9376 0 0 0 1.2942 1.2943c.8083-.5144 7.9393-5.0675 9.3903-6.5185 1.1486-1.1486 1.1486-3.0175 0-4.166-1.1485-1.1486-3.0175-1.1486-4.166-.0001Z"
                        fill="#30B2E6"
                    />
                </svg>
            )
        case IconTypeEnum.MediumIcon:
            return (
                <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M15.0624 4.5067V2.1973c-3.6138.2074-7.0028 1.6117-9.708 4.0225l4.1836 4.1835c.9781-.8142 2.0864-1.4282 3.2743-1.8212.1806-.8466.3371-1.5583.4421-2.031.217-.9767.9111-1.7313 1.808-2.0444Zm-6.8508 7.2221L4.0282 7.5454C1.6153 10.2497.2092 13.639.0005 17.2537h5.9173c.1875-2.0388.9813-3.9506 2.2938-5.5249Zm17.8703 5.5249h5.9173c-.2087-3.6147-1.6147-7.004-4.0277-9.7083l-4.1834 4.1834c1.3125 1.5742 2.1063 3.4861 2.2938 5.5249Zm-.0013 1.8747c-.3101 3.4061-2.1799 5.4843-2.9222 6.2266a.939.939 0 0 0 0 1.3281l2.8445 2.8447a.936.936 0 0 0 .664.2751.9358.9358 0 0 0 .664-.2751c2.8078-2.8074 4.445-6.4709 4.669-10.3994h-5.9193Zm-20.1612 0H0c.224 3.9285 1.8613 7.592 4.669 10.3995a.9363.9363 0 0 0 .664.275.9365.9365 0 0 0 .664-.275l2.8445-2.8447a.9393.9393 0 0 0 0-1.3282c-.7423-.7423-2.6121-2.8205-2.9221-6.2266ZM16.9375 2.1973v2.3095c.8969.313 1.591 1.0677 1.808 2.0444.1051.4728.2615 1.1844.4421 2.031 1.188.393 2.2963 1.007 3.2743 1.8212l4.1835-4.1835c-2.705-2.411-6.094-3.8152-9.7079-4.0226Zm-.9374 4.0263a.9375.9375 0 0 0-.9152.7342c-.2079.9353-2.0307 9.1971-2.0307 11.2491 0 1.6244 1.3215 2.9459 2.9458 2.9459 1.6243 0 2.9458-1.3215 2.9458-2.9459 0-2.052-1.8228-10.3138-2.0307-11.2491a.9373.9373 0 0 0-.915-.7342Z"
                        fill="#FAB400"
                    />
                </svg>
            )
        case IconTypeEnum.HardIcon:
            return (
                <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M15.0624 2.1968c-3.6138.2074-7.0029 1.6117-9.708 4.0225l4.1836 4.1835c1.5744-1.3106 3.486-2.1027 5.5244-2.289v-5.917Zm-6.8508 9.5311L4.0282 7.5444C1.6153 10.2487.2092 13.638.0005 17.2527h5.9173c.1875-2.0388.9813-3.9506 2.2938-5.5248Zm17.8703 5.5248h5.9173c-.2087-3.6147-1.6147-7.004-4.0277-9.7083l-4.1834 4.1835c1.3125 1.5742 2.1063 3.486 2.2938 5.5248Zm-.001 1.8752c-.1315 1.444-.5435 2.6483-1.0309 3.6144.4754.7332.8718 1.3528 1.1337 1.7643.7131 1.1208.5552 2.5594-.384 3.4987a2.8149 2.8149 0 0 1-.7709.5476l.9743.9744a.9363.9363 0 0 0 .6641.2751.9358.9358 0 0 0 .664-.2751c2.8077-2.8074 4.4449-6.4709 4.669-10.3994h-5.9193Zm-20.1615 0H0c.224 3.9285 1.8613 7.592 4.669 10.3995a.9363.9363 0 0 0 .664.275.9365.9365 0 0 0 .664-.275l2.8445-2.8447c.3667-.3668.3667-.9614 0-1.3281-.7423-.7424-2.6121-2.8206-2.9221-6.2267Zm20.726-12.9086c-2.705-2.4108-6.094-3.815-9.7079-4.0225v5.917c2.0384.1863 3.9501.9784 5.5244 2.289l4.1835-4.1835Zm-8.5623 9.9043c-1.1486-1.1485-3.0174-1.1485-4.166 0-1.1486 1.1486-1.1486 3.0175 0 4.166 1.451 1.451 8.5819 6.0041 9.3903 6.5185a.9375.9375 0 0 0 1.2943-1.2942c-.5145-.8083-5.0676-7.9393-6.5186-9.3903Z"
                        fill="#DF1A23"
                    />
                </svg>
            )
        case IconTypeEnum.ShieldIcon:
            return (
                <svg
                    width="16"
                    height="19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M0 0V10.63c.24 4.311 7.456 7.59 7.762 7.727l.238.105.236-.105c.308-.137 7.522-3.413 7.762-7.727L16 0H0Zm14.845 10.58C14.65 13.803 9.208 16.608 8 17.193c-1.208-.585-6.648-3.389-6.845-6.611V1.152h13.69v9.428Z"
                        fill={color}
                    />
                </svg>
            )
        case IconTypeEnum.ArmorIcon:
            return (
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M1.044 2.108.214.214l1.894.83 5.507 5.507L6.55 7.615 1.044 2.108Zm9.143 9.144c.05-.157.087-.317.104-.478l.046-.437.437-.046c.161-.017.321-.053.477-.103L9.447 8.385 8.383 9.449l1.805 1.803Zm4.966 3.074-2.351-2.35-.385-.386.118-.118.858-.858.418-.418.225-.225-.428-1.196-.643.643.108.304c-.514.443-1.332 1.012-2.243 1.109-.098.91-.666 1.729-1.108 2.243l-.304-.109-.643.643 1.196.428.225-.225.418-.418.857-.857.119-.119.385.385 2.351 2.353-.247.248.385.383 1.03-.292.292-1.03-.384-.383-.249.245Zm-9.927-4.035.436.046.046.437c.018.161.054.321.104.478l9.143-9.144.83-1.894-1.894.83-9.143 9.144c.156.05.316.086.478.103Zm1.05 2.784c-.444-.514-1.013-1.332-1.109-2.243-.91-.098-1.729-.667-2.243-1.108l.108-.305-.642-.642-.428 1.196.225.225.417.418.858.857.119.119-.385.385L.843 14.33l-.248-.25-.383.386.292 1.03 1.03.291.383-.383-.248-.247 2.353-2.353.385-.385.119.118.858.858.417.418.225.225 1.197-.428-.643-.643-.304.108Z"
                        fill={color}
                    />
                </svg>
            )
        case IconTypeEnum.HullIcon:
            return (
                <svg
                    width="15"
                    height="15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M13.688 9.839v1.127h-.505V8.217l-.502.5h-.006v2.249l-.637.63v.482l-1.641-.55v-.606l-1.264-.736v-2.32l.291-1.083V4.478l.352-1.295V.214L8.57 0 7.369.214v2.97l.644 5.282v2.984l-.954-.81-.95.81V8.466l.64-5.283V.214L5.546 0 4.345.214v2.97l.348 1.294v2.305l.292 1.087v2.316l-1.264.736v.606l-1.641.55v-.482l-.637-.63V8.717H1.44l-.505-.5v2.749H.43V9.839L0 9.413v4.761l.43.425v-.826h.652l4.192.64v-.64h.674v.566l1.11.661 1.111-.662v-.565h.675v.64l4.191-.64h.653v.826l.43-.425V9.413l-.43.426Z"
                        fill={color}
                    />
                </svg>
            )
        case IconTypeEnum.TooltipIcon:
            return (
                <svg
                    width="16"
                    height="16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8 12.61a.781.781 0 1 0 0-1.563.781.781 0 0 0 0 1.562Z"
                        fill={color}
                    />
                    <path
                        d="M8 0C3.579 0 0 3.578 0 8c0 4.421 3.578 8 8 8 4.421 0 8-3.578 8-8 0-4.421-3.578-8-8-8Zm0 14.75A6.746 6.746 0 0 1 1.25 8c0-3.73 3.019-6.75 6.75-6.75 3.73 0 6.75 3.019 6.75 6.75 0 3.73-3.019 6.75-6.75 6.75Z"
                        fill={color}
                    />
                    <path
                        d="M8 4.016a2.503 2.503 0 0 0-2.5 2.5.625.625 0 1 0 1.25 0c0-.69.56-1.25 1.25-1.25s1.25.56 1.25 1.25c0 .689-.56 1.25-1.25 1.25a.625.625 0 0 0-.625.625v1.562a.625.625 0 1 0 1.25 0V8.937A2.504 2.504 0 0 0 10.5 6.516c0-1.379-1.121-2.5-2.5-2.5Z"
                        fill={color}
                    />
                </svg>
            )
        case IconTypeEnum.ActivitiesIcon:
            return (
                <svg
                    width="26"
                    height="35"
                    viewBox="0 0 26 35"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M23.7222 20.505L25.0647 20.1113V19.125L23.7035 18.7238C23.6397 18.4388 23.546 18.165 23.4297 17.9025L24.3035 16.77L23.7222 15.9713L22.3572 16.455C22.1472 16.2713 21.9222 16.1063 21.6785 15.9675L21.7197 14.5163L20.7822 14.2125L19.961 15.4125C19.826 15.3975 19.6872 15.39 19.5447 15.39C19.4022 15.39 19.2597 15.3975 19.1247 15.4125L18.3035 14.2125L17.366 14.5163L17.4072 15.9675C17.1635 16.11 16.9385 16.2713 16.7285 16.455L15.3635 15.9713L14.7822 16.77L15.656 17.9025C15.5397 18.1613 15.446 18.4388 15.3822 18.7238L14.0135 19.125V20.1113L15.356 20.505C15.416 20.805 15.5097 21.09 15.626 21.3638L14.7785 22.4663L15.3597 23.265L16.661 22.8038C16.886 23.01 17.1335 23.1938 17.4035 23.3513L17.366 24.7238L18.3035 25.0275L19.076 23.9025C19.2297 23.9175 19.3835 23.9288 19.5447 23.9288C19.706 23.9288 19.8597 23.9175 20.0135 23.9025L20.786 25.0275L21.7235 24.7238L21.686 23.3513C21.9522 23.1975 22.1997 23.0138 22.4285 22.8038L23.7297 23.265L24.311 22.4663L23.4635 21.3638C23.5685 21.09 23.6585 20.805 23.7222 20.505ZM19.5372 22.6838C17.8647 22.6838 16.511 21.33 16.511 19.6575C16.511 17.985 17.8647 16.6313 19.5372 16.6313C21.2097 16.6313 22.5635 17.985 22.5635 19.6575C22.5635 21.33 21.2097 22.6838 19.5372 22.6838ZM13.0835 17.6325L12.7985 15.3225C13.151 15.1125 13.481 14.8725 13.7847 14.6063L15.896 15.585L16.616 14.6925L15.2172 12.8363C15.416 12.4838 15.581 12.1088 15.7122 11.7225L18.0297 11.5163L18.206 10.3838L16.0685 9.47629C16.0647 9.27379 16.0572 9.07129 16.0347 8.86504C16.0122 8.65879 15.9785 8.46004 15.941 8.26129L17.8422 6.92629L17.4297 5.85379L15.1197 6.13879C14.9097 5.78629 14.6697 5.45629 14.4035 5.15254L15.3747 3.03754L14.4822 2.31754L12.626 3.71629C12.2735 3.51754 11.8985 3.35254 11.5122 3.22129L11.306 0.903789L10.1735 0.727539L9.266 2.86504C9.0635 2.86879 8.861 2.87629 8.65475 2.89879C8.4485 2.92129 8.24975 2.95504 8.051 2.99254L6.716 1.09129L5.6435 1.50379L5.9285 3.81004C5.576 4.02004 5.246 4.26004 4.94225 4.52629L2.831 3.54754L2.111 4.44004L3.50975 6.29629C3.311 6.64879 3.146 7.02379 3.01475 7.41379L0.697247 7.62004L0.520996 8.75254L2.6585 9.66004C2.66225 9.86254 2.66975 10.065 2.69225 10.2713C2.71475 10.4775 2.7485 10.6763 2.786 10.875L0.884747 12.21L1.29725 13.2825L3.60725 12.9975C3.81725 13.35 4.05725 13.68 4.3235 13.9838L3.34475 16.0913L4.23725 16.8113L6.0935 15.4125C6.446 15.6113 6.821 15.7763 7.211 15.9075L7.41725 18.225L8.54975 18.4013L9.45725 16.2638C9.65975 16.26 9.86225 16.2525 10.0685 16.23C10.2747 16.2075 10.4735 16.1738 10.6722 16.1363L12.0072 18.0375L13.0835 17.6325ZM4.8485 10.1288C4.57475 7.56754 6.431 5.26879 8.99225 4.99504C11.5535 4.72129 13.8522 6.57754 14.126 9.13879C14.3997 11.7 12.5435 13.9988 9.98225 14.2725C7.421 14.5463 5.12225 12.69 4.8485 10.1288Z"
                        fill={color}
                    />
                    <path
                        d="M19.9986 9.57381C19.9986 7.48881 19.3949 5.54256 18.3599 3.90381C19.2861 4.24881 20.1374 4.69881 20.8461 5.28756C24.2324 8.09256 24.5249 11.2688 24.5249 13.2001C24.5249 13.7401 24.5136 14.3138 24.4611 14.9213C23.2199 13.6238 21.4761 12.8101 19.5411 12.8101C19.5261 12.8101 19.5149 12.8138 19.4999 12.8138C19.8224 11.7863 19.9986 10.7026 19.9986 9.57381ZM12.7311 19.6613C11.6736 20.0138 10.5411 20.2088 9.36361 20.2088C6.35986 20.2088 3.64861 18.9601 1.71361 16.9576C1.49236 17.3588 1.28986 17.6551 1.19236 17.7976C0.899864 18.2326 0.266113 18.7388 0.266113 19.5563C0.266113 20.3738 0.918614 20.4376 1.48861 20.6213C2.05861 20.8051 1.93111 21.5851 1.94986 21.9263C1.96861 22.2676 1.69111 22.3313 1.68361 22.8376C1.67611 23.3438 2.51986 23.6551 2.51986 23.6551C2.51986 23.6551 2.24236 23.7638 2.12611 24.1801C2.00986 24.5963 2.12611 24.8438 2.53111 25.0726C2.93611 25.3013 3.11236 25.4963 3.11236 26.5538C3.11236 27.6113 3.34111 28.0876 4.39861 28.7251C5.45611 29.3588 6.98611 28.5638 7.76611 28.5226C9.98986 28.4026 10.1061 32.8988 10.0161 34.6088C10.6536 34.6838 11.3024 34.7251 11.9624 34.7251C15.8811 34.7251 19.4849 33.3863 22.3499 31.1438C21.5661 29.9063 20.9886 28.6351 20.7111 26.9288C20.6774 26.7188 20.6511 26.5238 20.6249 26.3326C20.2686 26.3888 19.9049 26.4263 19.5336 26.4263C15.7911 26.4263 12.7536 23.4038 12.7311 19.6613Z"
                        fill={color}
                    />
                </svg>
            )
        case IconTypeEnum.Careers:
            return (
                <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M14.4525 0.651446V29.1032H0.75V24.9852C0.75 24.9852 6.70547 22.5669 9.11062 21.4185C11.0761 20.48 10.5773 17.1069 10.5773 17.1069C10.5773 17.1069 9.95391 16.5294 9.79969 15.5286C9.64219 14.5311 9.46828 13.3925 9.46828 13.3925C9.46828 13.3925 8.94328 13.491 8.68734 12.8314C8.43469 12.1719 8.37563 11.9324 8.22141 11.1941C8.06719 10.4558 7.79812 8.72988 8.45437 8.7791C8.52 8.78566 8.81531 8.9891 8.80219 8.58879C8.80219 8.58879 7.90969 1.0091 14.4525 0.651446ZM19.2891 17.1069C19.2891 17.1069 19.3219 17.0774 19.3645 17.0249V2.34785C19.0003 1.9541 18.5639 1.60301 18.0356 1.32738V29.1064H19.3645V19.3874C19.1217 18.2488 19.2891 17.1069 19.2891 17.1069ZM21.1791 12.8347C21.4317 12.1752 21.4908 11.9357 21.645 11.1974C21.8025 10.4591 22.0683 8.73316 21.412 8.78238C21.3464 8.78894 21.0511 8.99238 21.0642 8.59207C21.0642 8.59207 21.2841 6.72176 20.7066 4.79894V13.3597C20.8673 13.2941 21.0544 13.1563 21.1791 12.8347ZM24.4111 23.0329V29.1064H25.6612V23.5611C25.2544 23.3872 24.8344 23.21 24.4111 23.0329ZM20.7558 21.4185C20.7394 21.4086 20.723 21.3988 20.7066 21.3922V29.1064H22.0683V22.0189C21.5728 21.7958 21.1233 21.5924 20.7558 21.4185ZM15.1219 0.641602V29.1032H16.7002V0.828633C16.2277 0.71707 15.6994 0.654727 15.1219 0.641602ZM29.1164 24.9852C29.1164 24.9852 28.6833 24.808 28.0073 24.5324V29.1064H29.1164V24.9852Z"
                        fill="#C0C0C0"
                    />
                </svg>
            )
        case IconTypeEnum.Ships:
            return (
                <svg
                    width="28"
                    height="30"
                    viewBox="0 0 28 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M27.1511 19.68V21.9337H26.1444V17.4337V16.4363L25.1489 17.4337H25.1376V21.9337L23.8755 23.19V24.1538L20.6187 23.055V21.8438L18.1132 20.37V15.735L18.6955 13.5637V8.95875L19.3866 6.36375V0.42375L17.0013 0L14.616 0.42375V6.36375L15.8895 16.9313V22.9012L14 21.2775L12.1105 22.9012V16.9313L13.3877 6.36375V0.42375L10.9987 0L8.61336 0.42375V6.36375L9.30829 8.95875V13.5637L9.89053 15.7388V20.37L7.37752 21.8438V23.055L4.1245 24.1538V23.19L2.86236 21.9337V17.4337H2.85484L1.85565 16.4363V17.4337V21.9337H0.84894V19.68L0 18.8287V19.68V28.3538L0.84894 29.2013V27.5475H1.65656H2.14489L10.4577 28.8263V27.5475H11.5546H11.7988V28.68L14 30L16.2012 28.68V27.5475H16.4454H17.5423V28.8263L25.8551 27.5475H26.3472H27.1511V29.2013L28 28.3538V19.68V18.8287L27.1511 19.68Z"
                        fill="#C0C0C0"
                    />
                </svg>
            )
        case IconTypeEnum.AirCareerProgram:
            return (
                <svg
                    width="44"
                    height="44"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M26.2494 41.8606C34.3915 40.8453 40.8448 34.392 41.8602 26.2499H38.8404C37.887 32.9315 32.7516 38.2188 26.2494 39.2226V41.8606Z"
                        fill="#C0C0C0"
                    />
                    <path
                        d="M38.8404 21.7499H41.8602C40.8448 13.6078 34.3915 7.15447 26.2494 6.13916V8.7772C32.7516 9.78102 37.887 15.0683 38.8404 21.7499Z"
                        fill="#C0C0C0"
                    />
                    <path
                        d="M21.7494 41.8606V39.2226C15.2472 38.2188 10.1119 32.9315 9.15847 26.2499H6.13867C7.15398 34.392 13.6073 40.8453 21.7494 41.8606Z"
                        fill="#C0C0C0"
                    />
                    <path
                        d="M6.13867 21.7499H9.15847C10.1119 15.0683 15.2472 9.78102 21.7494 8.7772V6.13916C13.6073 7.15447 7.15398 13.6078 6.13867 21.7499Z"
                        fill="#C0C0C0"
                    />
                    <path
                        d="M32.2494 18.7499C32.2494 20.4068 30.9063 21.7499 29.2494 21.7499C27.5926 21.7499 26.2494 20.4068 26.2494 18.7499C26.2494 17.0931 27.5926 15.7499 29.2494 15.7499C30.9063 15.7499 32.2494 17.0931 32.2494 18.7499Z"
                        fill="#C0C0C0"
                    />
                    <path
                        d="M29.2494 32.2499C30.9063 32.2499 32.2494 30.9068 32.2494 29.2499C32.2494 27.5931 30.9063 26.2499 29.2494 26.2499C27.5926 26.2499 26.2494 27.5931 26.2494 29.2499C26.2494 30.9068 27.5926 32.2499 29.2494 32.2499Z"
                        fill="#C0C0C0"
                    />
                    <path
                        d="M21.7494 18.7499C21.7494 20.4068 20.4063 21.7499 18.7494 21.7499C17.0926 21.7499 15.7494 20.4068 15.7494 18.7499C15.7494 17.0931 17.0926 15.7499 18.7494 15.7499C20.4063 15.7499 21.7494 17.0931 21.7494 18.7499Z"
                        fill="#C0C0C0"
                    />
                    <path
                        d="M18.7494 32.2499C20.4063 32.2499 21.7494 30.9068 21.7494 29.2499C21.7494 27.5931 20.4063 26.2499 18.7494 26.2499C17.0926 26.2499 15.7494 27.5931 15.7494 29.2499C15.7494 30.9068 17.0926 32.2499 18.7494 32.2499Z"
                        fill="#C0C0C0"
                    />
                </svg>
            )
        default:
            return <></>
    }
}

Icons.defaultProps = {
    color: IconColorEnum.GrayColor,
}
export function HomeIcon(): JSX.Element {
    return <Icons icon={IconTypeEnum.HomeIcon} />
}

export function AuraIcon(): JSX.Element {
    return <Icons icon={IconTypeEnum.AuraIcon} />
}

export function ArrowRightIcon(): JSX.Element {
    return (
        <Icons icon={IconTypeEnum.ArrowRight} color={IconColorEnum.PinkColor} />
    )
}

export function ArrowDownIcon(): JSX.Element {
    return (
        <Icons icon={IconTypeEnum.ArrowDown} color={IconColorEnum.WhiteColor} />
    )
}

export function TextIcon(): JSX.Element {
    return (
        <Icons icon={IconTypeEnum.TextIcon} color={IconColorEnum.GrayColor} />
    )
}

export function EasyIcon(): JSX.Element {
    return (
        <Icons icon={IconTypeEnum.EasyIcon} color={IconColorEnum.BlueColor} />
    )
}

export function MediumIcon(): JSX.Element {
    return (
        <Icons
            icon={IconTypeEnum.MediumIcon}
            color={IconColorEnum.YellowColor}
        />
    )
}

export function HardIcon(): JSX.Element {
    return <Icons icon={IconTypeEnum.HardIcon} color={IconColorEnum.RedColor} />
}

export function ShieldIcon(): JSX.Element {
    return (
        <Icons icon={IconTypeEnum.ShieldIcon} color={IconColorEnum.GrayColor} />
    )
}

export function ArmorIcon(): JSX.Element {
    return (
        <Icons icon={IconTypeEnum.ArmorIcon} color={IconColorEnum.GrayColor} />
    )
}

export function HullIcon(): JSX.Element {
    return (
        <Icons icon={IconTypeEnum.HullIcon} color={IconColorEnum.GrayColor} />
    )
}

export function TooltipIcon(): JSX.Element {
    return (
        <Icons
            icon={IconTypeEnum.TooltipIcon}
            color={IconColorEnum.GrayColor}
        />
    )
}
